<p>brop-compound-settings works!</p>
